import React from "react";
import PropTypes from "prop-types";

const MenuRow = ({ children, minWidth = 24, minHeight = 36 }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        minWidth,
        minHeight,
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );
};

MenuRow.propTypes = {
  children: PropTypes.node,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
};

export default MenuRow;
